// @flow
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import React from "react";
import type { Game, TicketReservation } from "../../common/types";
import Typography from "@material-ui/core/Typography";

function createData(
  id: string,
  label: string,
  value: number,
  subLabel: string
) {
  return { id, label, value, subLabel };
}

type Props = {
  game: Game,
  location: Location,
  ticketReservations: Array<TicketReservation>,
};

function GameAdminInfos({ game, location, ticketReservations }: Props) {
  const {
    ticketReservationCount = 0,
    visitorsWithReservationCount = 0,
    visitorsUnknownCount = 0,
  } = game;

  const openPayedTicketReservations = ticketReservations.filter(
    (tr) =>
      tr.paymentStatus === "COMPLETE" &&
      (tr.amountRedeemed == null || tr.amountRedeemed < 1)
  );
  const ticketReservationPayedCount = openPayedTicketReservations.length;

  const visitorSlots = game.visitorSlots || location.visitorSlots;

  const visitorSlotsAvailable =
    visitorSlots - ticketReservationCount - visitorsUnknownCount;

  const rows = [
    createData(
      "visitorSlotsAvailable",
      "Verfügbar für Abendkasse",
      visitorSlotsAvailable
    ),
    createData(
      "ticketReservationsOpen",
      "Offene unbezahlte Reservierungen",
      ticketReservationCount -
        visitorsWithReservationCount -
        ticketReservationPayedCount,
      "Verfallen 15min. vor Spielbeginn"
    ),
    createData(
      "ticketReservationsOpenPayed",
      "Offene bezahlte Reservierungen",
      ticketReservationPayedCount
    ),
    createData(
      "visitorsWithReservationCount",
      "Eingelöste Reservierungen",
      visitorsWithReservationCount
    ),
    createData(
      "visitorsUnknownCount",
      "Besucher ohne Reservierung",
      visitorsUnknownCount
    ),
  ];

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.label}
                {row.subLabel && (
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    component="div"
                  >
                    {row.subLabel}
                  </Typography>
                )}
              </TableCell>
              <TableCell align="right">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default GameAdminInfos;
